import React from 'react';
import Select from '../../../components/ui/Select';

const FilterBar = ({ 
  statusFilter, 
  onStatusFilterChange, 
  playFilter, 
  onPlayFilterChange,
  alphabetFilter,
  onAlphabetFilterChange,
  plays 
}) => {
  const statusOptions = [
    { value: 'all', label: 'All Status' },
    { value: 'complete', label: 'Complete' },
    { value: 'incomplete', label: 'Incomplete' },
    { value: 'no-audio', label: 'Missing Audio' }
  ];

  const playOptions = [
    { value: 'all', label: 'All Plays' },
    ...plays?.map(play => ({ value: play?.id, label: play?.title }))
  ];

  const alphabetOptions = [
    { value: 'all', label: 'All Letters' },
    { value: 'a-e', label: 'A - E' },
    { value: 'f-j', label: 'F - J' },
    { value: 'k-o', label: 'K - O' },
    { value: 'p-t', label: 'P - T' },
    { value: 'u-z', label: 'U - Z' }
  ];

  return (
    <div className="bg-card border-b border-border">
      <div className="max-w-screen-2xl mx-auto px-6 py-4">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
          <Select
            label="Status"
            options={statusOptions}
            value={statusFilter}
            onChange={onStatusFilterChange}
          />
          <Select
            label="Play"
            options={playOptions}
            value={playFilter}
            onChange={onPlayFilterChange}
          />
          <Select
            label="Alphabetical Range"
            options={alphabetOptions}
            value={alphabetFilter}
            onChange={onAlphabetFilterChange}
          />
        </div>
      </div>
    </div>
  );
};

export default FilterBar;